import React from "react";
import { useNavigate } from "react-router-dom";

const FeatureCard = ({ item }) => {
  const navigate = useNavigate();

  return (
    <div
      className="group relative bg-[#162035] border border-white/10 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:border-[#F05A22]/40 hover:shadow-[0_0_30px_rgba(240,90,34,0.15)] hover:-translate-y-1"
      onClick={() => navigate(item?.link)}
    >
      {/* Card body */}
      <div className="p-6">
        <h2 className="text-lg font-bold text-white mb-2 group-hover:text-[#F05A22] transition-colors">
          {item?.title}
        </h2>
        <p className="text-white/50 text-sm leading-relaxed">
          {item?.desc}
        </p>
      </div>

      {/* Card footer */}
      <div
        className="px-6 py-5 flex flex-col items-center gap-3"
        style={{ background: "linear-gradient(135deg, #1B2B5E, #111d42)" }}
      >
        <p className="text-white/60 text-xs font-medium tracking-wide text-center">{item?.subTitle}</p>
        <div className="h-[90px] sm:h-[100px] flex items-center justify-center">
          <img
            src={item?.img}
            className="max-h-full max-w-full object-contain opacity-90 group-hover:scale-105 transition-transform duration-300"
            alt={item?.title}
          />
        </div>
      </div>

      {/* Orange accent line on hover */}
      <div className="absolute bottom-0 left-0 w-0 h-0.5 group-hover:w-full transition-all duration-500"
        style={{ background: "linear-gradient(90deg, #F05A22, #E8407A)" }}
      />
    </div>
  );
};

export default FeatureCard;
